import { createSelector } from 'reselect';

import { RootState } from '../types';

export const uiSelector = (state: RootState) => state.ui;

export const progressBarSelector = createSelector(
  uiSelector,
  (ui) => ui.progressBar ?? {}
);

const myBetsSelector = createSelector(
  uiSelector,
  (ui) => ui.myBets ?? {}
);

export const isHighlightedMyBetsSelector = createSelector(
  myBetsSelector,
  (myBets) => (myBets.highlighted ?? false) as boolean
);

export const isParentWindowFullscreenSelector = createSelector(
  uiSelector,
  (ui) => ui.isParentWindowFullscreen ?? false
);

// This is to prevent the tutorial from showing up again when reconnecting
// It should default to true
export const showTutorialSelector = createSelector(
  uiSelector,
  (ui) => ui.showTutorial ?? true
);

export const boardToggledSelector = createSelector(
  uiSelector,
  (ui) => ui.boardToggled
);

export const desktopBoardToggleHeightSelector = createSelector(
  uiSelector,
  (ui) => ui.desktopBoardToggleHeight
);
